import { Outlet } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";
import { Box } from "@mui/material";

const BasicLayout = (props) => {
    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box component={'main'} sx={{ flex: 1 }}>

                <Outlet />
            </Box>
            <Footer />
        </Box>
    )
}

export default BasicLayout;